import React, { useEffect, useMemo, useRef, useState } from "react";
import useSound from "use-sound";

export default function useScreenshotAnimation() {
  const flashDuration = 150;

  const [showFlash, setShowFlash] = useState(false);
  const [playShutter] = useSound("/assets/sounds/shutter.mp3", {
    volume: 0.2,
  });

  const ScreenshotFlash = () => {
    return (
      <div
        style={{
          position: "absolute",
          left: 0,
          top: 0,
          width: "100%",
          height: "100%",
          background: showFlash
            ? "rgba(255,255,255,0.9)"
            : "rgba(255,255,255,0)",
          transition: `background ${flashDuration / 1000}s`,
          zIndex: 1,
          pointerEvents: "none",
        }}
      />
    );
  };

  const playScreenshotAnimation = () => {
    setShowFlash(true);
    setTimeout(() => {
      setShowFlash(false);
    }, flashDuration);
    playShutter();
  };

  return { ScreenshotFlash, playScreenshotAnimation };
}
